/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: wrong document type
 * @export
 * @interface PaxCheckRecognizedDocumentKindMismatch
 */
export interface PaxCheckRecognizedDocumentKindMismatch {
    /**
     * Which document types were expected
     * @type {Array<string>}
     * @memberof PaxCheckRecognizedDocumentKindMismatch
     */
    expectedTypes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckRecognizedDocumentKindMismatch
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckRecognizedDocumentKindMismatch interface.
 */
export function instanceOfPaxCheckRecognizedDocumentKindMismatch(value: object): value is PaxCheckRecognizedDocumentKindMismatch {
    if (!('expectedTypes' in value) || value['expectedTypes'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckRecognizedDocumentKindMismatchFromJSON(json: any): PaxCheckRecognizedDocumentKindMismatch {
    return PaxCheckRecognizedDocumentKindMismatchFromJSONTyped(json, false);
}

export function PaxCheckRecognizedDocumentKindMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRecognizedDocumentKindMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'expectedTypes': json['expected_types'],
        'type': json['type'],
    };
}

export function PaxCheckRecognizedDocumentKindMismatchToJSON(json: any): PaxCheckRecognizedDocumentKindMismatch {
    return PaxCheckRecognizedDocumentKindMismatchToJSONTyped(json, false);
}

export function PaxCheckRecognizedDocumentKindMismatchToJSONTyped(value?: PaxCheckRecognizedDocumentKindMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_types': value['expectedTypes'],
        'type': value['type'],
    };
}

